import {
  CollapsibleRail as KitCollapsibleRail,
  CollapsibleRailToggle as KitToggle,
  cn,
  type CollapsibleRailProps,
  type CollapsibleRailToggleProps,
} from '@chekinapp/ui';
import {
  RAIL_CONTENT_REVEAL,
  RAIL_STRIP_REVEAL,
  RAIL_VARIANTS,
  type RailVariant,
} from './railClasses';

type RailToggleProps = Omit<CollapsibleRailToggleProps, 'breakpointClasses'> & {
  rail: RailVariant;
};

function RailToggle({rail, ...props}: RailToggleProps) {
  return (
    <KitToggle breakpointClasses={{toggle: RAIL_VARIANTS[rail].toggle}} {...props} />
  );
}

type Props = Omit<CollapsibleRailProps, 'breakpointClasses'> & {
  rail: RailVariant;
  hasToggled?: boolean;
};

function CollapsibleRail({rail, hasToggled, contentClassName, ...props}: Props) {
  return (
    <KitCollapsibleRail
      breakpointClasses={{
        ...RAIL_VARIANTS[rail],
        strip: cn(RAIL_VARIANTS[rail].strip, hasToggled && RAIL_STRIP_REVEAL),
      }}
      contentClassName={cn(contentClassName, hasToggled && RAIL_CONTENT_REVEAL)}
      {...props}
    />
  );
}

export {CollapsibleRail, RailToggle};
